import React from 'react'
import Header from './Header'
import Footer from './Footer'
import SEOHead from '@components/common/SEOHead'
import { SEOData } from '@types/index'

interface LayoutProps {
  children: React.ReactNode
  seo?: SEOData
  className?: string
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  seo,
  className = ''
}) => {
  return (
    <>
      <SEOHead {...seo} />
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className={`flex-grow ${className}`}>
          {children}
        </main>
        <Footer />
      </div>
    </>
  )
}

export default Layout